import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import type { DeleteCampaignResponse } from "../../types/gamePass";
import { getPrivateInstance } from "../_privateInstance";
import { removeCampaignFromLists } from "./campaignQueryCache";

const buildDeleteCampaignUrl = (campaignId: string): string =>
  API_ROUTES.DELETE_CAMPAIGN.replace("{campaign_id}", campaignId);

const deleteCampaign = async (campaignId: string): Promise<string> => {
  await getPrivateInstance().delete<DeleteCampaignResponse>(
    buildDeleteCampaignUrl(campaignId),
  );
  return campaignId;
};

/**
 * Delete a draft / scheduled Monthly Challenge campaign
 * (`DELETE /gamepass/v2/admin/campaigns/{campaign_id}`). Mirrors
 * `useDeleteSeason`: optimistically drops the row from every cached listing.
 */
export const useDeleteCampaign = (): UseMutationResult<string, Error, string> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["game-pass", "campaigns", "delete"],
    mutationFn: deleteCampaign,
    onSuccess: (campaignId) => removeCampaignFromLists(queryClient, campaignId),
  });
};
